export class Study {
    constructor(
        public id: string,
        public description: string,
        public noAdmissionOnPortal?: boolean
    ) {}
}

export class Offering {
    constructor(
        public periodId: string,
        public description: string,
        public year: string
    ) {}
}

export class StudyId {
    constructor(
        public id: string
    ) {}
}